module.exports = __webpack_public_path__ + "static/media/algo.f5711eaa.svg";